import React, { useEffect, useState } from "react";

import { formatTimeSeriesData, populateXYaxisTime } from "utils/reportUtils";
import { notAllZeros, timestampInDefaultFormat } from "utils/utils";
import { TimeSeriesWidgetFormStrings } from "constants/constantStrings";

import PlotlyReport from "./PlotlyReport";

import "./index.scss";

const TimeSeriesChart = ({ report, data, intialLayout, isLoading, error, width, setError, startTime, endTime }) => {
  const [chartData, setChartData] = useState(null);
  const [layout, setLayout] = useState({ ...intialLayout });

  useEffect(() => {
    const config = JSON.parse(JSON.stringify(intialLayout));
    if (startTime && endTime) {
      config.xaxis.range = [timestampInDefaultFormat(startTime), timestampInDefaultFormat(endTime)];
    }
    setLayout(config);
  }, [startTime]);

  useEffect(() => {
    if (data && data.Data) {
      const traceData = [];
      const processData = formatTimeSeriesData(data);
      if (processData && processData.Time && Object.keys(processData.Time).length) {
        let count = 1;
        if (processData["Yaxis"]) {
          for (let tag = 0; tag < processData["Yaxis"].length; tag++) {
            if (notAllZeros(processData["Yaxis"][tag])) {
              const trace = populateXYaxisTime(processData.Time, processData["Yaxis"][tag], "scatter", count);
              traceData.push(trace);
              count++;
            }
          }
          setChartData(traceData);
        }
      } else {
        report.error = TimeSeriesWidgetFormStrings.noDataFound;
        setError(TimeSeriesWidgetFormStrings.noDataFound);
      }
    }
  }, [data]);

  return <PlotlyReport chartData={chartData} layout={layout} isLoading={isLoading} error={error} report={report} width={width} />;
};

export default TimeSeriesChart;
